var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function BlogTile(_a) {
    var imgSrc = _a.imgSrc, title = _a.title;
    return (_jsxs("div", __assign({ className: "flex w-full md:w-[380px] h-[82px] md:h-[140px] justify-start items-center border-2 border-border-shoe rounded-[12px] bg-surface-white overflow-hidden relative group transition-background duration-200 ease-in-out before:absolute before:inset-0 before:bg-transparent md:hover:before:bg-[rgba(0,0,0,0.2)] before:transition-colors before:duration-200 before:ease-in-out before:z-10" }, { children: [_jsx("div", { style: {
                    backgroundImage: "url(".concat(imgSrc, ")"),
                }, className: "h-[82px] w-[82px] md:w-[140px] md:h-[140px] shrink-0 bg-cover bg-center border-r-2 border-shoe group-hover:scale-105 transition-transform duration-200 ease-in-out" }), _jsx("div", __assign({ className: "self-stretch px-sm-m my-auto" }, { children: _jsx("h5", __assign({ className: "text-[26px] font-bold leading-[1.2] font-display line-clamp-3 text-text-body" }, { children: title })) }))] })));
}
export default BlogTile;
